module.exports = __webpack_public_path__ + "img/navbar.044f58f4.webp";